import styled from 'styled-components';

import { transition } from 'theme/theme';

import { ShareButton } from './ShareButton';

export const SocialButton = styled(ShareButton)`
  margin: 6px;
  transition: all ${transition};
`;
